export enum MessageContextType {
  MassMessage = 'MassMessage',
  FollowUpMessage = 'FollowUpMessage',
  ExpiringFans = 'ExpiringFans',
  WelcomeMessage = 'WelcomeMessage',
}
